import { useCallback } from 'react';
import qs from 'qs';

import { Empty, Pagination, Space } from 'antd';
import axios, { AxiosResponse } from 'axios';
import BoardListSkeleton from 'components/common/skeleton/news/BoardListSkeleton';
import useAPI from 'hooks/useAPI';
import { useRouter } from 'next/router';

import { IQuery } from 'types/common';
import { INewsItem, INewsList } from 'types/news';

import SearchBar from 'components/common/SearchBar';

import NewsSectionTab from '../NewsSectionTab';
import PressReleaseList from './PressReleaseList';

interface IGetNewsList {
  locale?: 'ko' | 'en';
  nextPage?: number;
  search?: string;
  pageSize?: number;
}

function PressReleaseCard() {
  const stringifyQuery = (query: IQuery) => qs.stringify(query);

  const getNewsList = useCallback(
    async ({
      locale = 'ko',
      nextPage,
      search = '',
      pageSize = 9,
    }: IGetNewsList) => {
      const route = locale === 'ko' ? 'news-kos' : 'news-ens';
      const query: IQuery = {
        pagination: {
          page: Number(nextPage) || 1,
          pageSize: pageSize,
        },
        populate: '*',
        sort: 'displayDate:desc',
        ...(!!search.length && {
          filters: {
            $or: [
              {
                title: {
                  $contains: search,
                },
              },
              {
                content: {
                  $contains: search,
                },
              },
            ],
          },
        }),
      };
      const newsData: AxiosResponse<INewsList> = await axios.get(
        `/api/${route}?${stringifyQuery(query)}`
      );
      return newsData;
    },
    []
  );

  const router = useRouter();
  const { locale, query } = router;
  const { page, search } = query;

  const listItemURLQuery = `page=${Number(page) || 1}${
    search ? `&search=${search}` : ''
  }`;

  const { data, isLoading, isError, handlePagination, handleSearch } = useAPI<
    INewsItem[]
  >((args) => getNewsList({ locale, nextPage: page, search, ...args }));

  const renderer = () => {
    if (isLoading) {
      return <BoardListSkeleton />;
    }
    if (isError) {
      /* TODO: 에러 화면 정리 */
      return <>에러가 발생했습니다.</>;
    }
    if (!!data?.data.length) {
      return (
        <>
          <PressReleaseList
            data={data.data}
            listItemURLQuery={listItemURLQuery}
          />
          <Pagination
            defaultPageSize={9}
            showSizeChanger={false}
            current={Number(page) || 1}
            total={data.meta.pagination.total}
            onChange={handlePagination}
            style={{
              marginBottom: 200,
            }}
          />
        </>
      );
    }
    return (
      /* TODO: 빈 화면 정리 */
      <Empty description="등록된 보도자료가 없습니다." />
    );
  };

  return (
    <Space
      direction="vertical"
      size="middle"
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <NewsSectionTab />
      <SearchBar onSearch={handleSearch} defaultValue={search as string} />
      {renderer()}
    </Space>
  );
}

export default PressReleaseCard;
